<template>
  <div>
    <el-dialog title="个人中心" :visible.sync="visible" width="450px" @close="resetForm">
      <el-tabs v-model="activeTab">
        <!-- 基本信息选项卡 -->
        <el-tab-pane label="基本信息" name="info">
          <el-form :model="infoForm" label-width="80px">
            <el-form-item label="用户名">
              <el-input v-model="infoForm.username" disabled />
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="infoForm.realName" />
            </el-form-item>
            <el-form-item label="状态">
              <el-tag :type="infoForm.status === 'active' ? 'success' : 'danger'">
                {{ infoForm.status === 'active' ? '启用' : '停用' }}
              </el-tag>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="updateProfile">保存修改</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <!-- 修改密码选项卡 -->
        <el-tab-pane label="修改密码" name="password">
          <el-form :model="pwdForm" :rules="pwdRules" ref="pwdForm" label-width="100px">
            <el-form-item label="原密码" prop="oldPassword">
              <el-input type="password" v-model="pwdForm.oldPassword" show-password />
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input type="password" v-model="pwdForm.newPassword" show-password />
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword">
              <el-input type="password" v-model="pwdForm.confirmPassword" show-password />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitPassword">确认修改</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import { getUserProfile, updateUserProfile, changePassword } from '@/api/user'

export default {
  name: 'Profile',
  data() {
    const validateConfirm = (rule, value, callback) => {
      if (value !== this.pwdForm.newPassword) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      visible: false,
      activeTab: 'info',
      infoForm: {
        username: '',
        realName: '',
        status: ''
      },
      pwdForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      pwdRules: {
        oldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 8, message: '密码长度至少8位', trigger: 'blur' },
          {
            pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])|(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*])|(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])/,
            message: '密码需包含大小写字母、数字、特殊字符中的至少三种',
            trigger: 'blur'
          }
        ],
        confirmPassword: [{ required: true, validator: validateConfirm, trigger: 'blur' }]
      }
    }
  },
  methods: {
    open() {
      this.visible = true
      this.loadUserInfo()
    },
    async loadUserInfo() {
      try {
        const res = await getUserProfile()
        this.infoForm = res
      } catch (err) {
        this.$message.error('加载个人信息失败')
      }
    },
    async updateProfile() {
      try {
        await updateUserProfile({ realName: this.infoForm.realName })
        this.$message.success('保存成功')
        localStorage.setItem('username', this.infoForm.realName || this.infoForm.username)
        this.$store.commit('SET_USERNAME', this.infoForm.realName)
      } catch (err) {
        this.$message.error(err.message || '保存失败')
      }
    },
    async submitPassword() {
      await this.$refs.pwdForm.validate()
      try {
        await changePassword({
          oldPassword: this.pwdForm.oldPassword,
          newPassword: this.pwdForm.newPassword
        })
        this.$message.success('密码修改成功，请重新登录')
        this.visible = false
        // 退出登录
        localStorage.clear()
        this.$router.push('/login')
      } catch (err) {
        this.$message.error(err.message || '修改失败')
      }
    },
    resetForm() {
      this.pwdForm = { oldPassword: '', newPassword: '', confirmPassword: '' }
      this.$refs.pwdForm?.resetFields()
    }
  }
}
</script>